import { ThemedDropdown } from "@vega-core/components/Form/Controls/Dropdown/ThemedDropdown/ThemedDropdown";
import { type OptionType } from "@vega-core/models/options";

import {
  type DropdownFilterConfig,
  type FilterState,
  FilterType,
  type FilterValue,
  type TableFilterId,
} from "../types";
import { getFilterValue } from "../utils/getFilterValue";

type Props = {
  filter: DropdownFilterConfig;
  isLoading: boolean;
  filterState: FilterState;
  onFilterChange: (filterId: string, value: FilterValue) => void;
  showLabel?: boolean;
  tableId: TableFilterId;
  disabled?: boolean;
};

export function DropdownFilter({
  filter,
  isLoading,
  filterState,
  onFilterChange,
  showLabel,
  tableId,
  disabled = false,
}: Props) {
  const dropdownValue =
    getFilterValue(filterState, filter.id, FilterType.Dropdown)?.value ?? "";

  // Use filter-level showLabel if specified, otherwise fall back to prop
  const shouldShowLabel = filter.showLabel ?? showLabel;

  return (
    <ThemedDropdown
      {...filter.props}
      disabled={Boolean(filter.props.disabled || isLoading || disabled)}
      label={shouldShowLabel ? filter.label : undefined}
      name={`${tableId}-${filter.id}`}
      onChange={(value: OptionType | undefined) =>
        onFilterChange(filter.id, value)
      }
      options={
        (filter.props.options as OptionType[] | undefined) ||
        ([] as OptionType[])
      }
      value={dropdownValue}
    />
  );
}
